import React, { Component } from 'react';
import { Modal } from '../../shared-components';
import { GaContext } from '../../../googleAnalyticsContext/GaContext';
import PropTypes from 'prop-types';
import {withFirebase} from '../../../Firebase';
import {
    KEYWORD_FILTERING_TOPIC_MODAL_STATE,
    CHOOSE_DATA_SOURCE_TOPIC_MODAL_STATE,
    UPLOAD_DATA_TOPIC_DETAILS_MODAL_STATE,
    UPLOAD_FILES_MODAL_STATE,
    LOADING_MODAL_STATE,
    DATA_SUMMARY_WITH_ERRORS_MODAL_STATE,
    DATA_SUMMARY_MODAL_STATE,
    REMOVE_ROWS_WITH_ERRORS_CONFIRMATION_STATE,
    CONFIRM_CANCEL_TOPIC_CREATION_STATE,
    EDIT_TOPIC_MODAL_STATE,
    MODAL_STATES_REQUIRING_CANCEL_CONFIRMATION
} from './constants/constants';
import AddTopic from './AddTopic';
import ChooseDataSourceModal from './ChooseDataSourceModal';
import UploadDataTopicDetailsModal from './file-upload/UploadDataTopicDetailsModal';
import UploadFilesModal from './file-upload/UploadFilesModal';
import DataSummaryWithErrorsModal from './file-upload/DataSummaryWithErrorsModal';
import DataSummaryModal from './file-upload/DataSummaryModal';
import LoadingModal from './file-upload/LoadingModal';
import RemoveRowsConfirmationModal from './file-upload/RemoveRowsConfirmationModal';
import CancelTopicCreationModal from './file-upload/CancelTopicCreationModal';
import EditTopicModal from './EditTopicModal';

class CreateTopicModalManager extends Component {
  
    static propTypes = {
      show:                                         PropTypes.bool.isRequired,
      toggleModal:                                  PropTypes.oneOfType([PropTypes.bool,PropTypes.func]).isRequired,
      modalState:                                   PropTypes.string.isRequired,
      changeModalState:                             PropTypes.func.isRequired,
      type:                                         PropTypes.string.isRequired,
      changeAddTopicActionType:                     PropTypes.func.isRequired,
      createTopics:                                 PropTypes.func.isRequired,
      topicData:                                    PropTypes.object.isRequired,
      newUploadDataTopicData:                       PropTypes.object.isRequired,
      allTopicNames:                                PropTypes.array.isRequired,
      allCategories:                                PropTypes.array.isRequired,
      resetAddTopicForm:                            PropTypes.bool.isRequired,
      createTopicsBeginStatus:                      PropTypes.oneOfType([PropTypes.bool,PropTypes.func]).isRequired,
      updateTopicsBegin:                            PropTypes.oneOfType([PropTypes.bool,PropTypes.func]).isRequired,
      retrieveTopicPreview:                         PropTypes.func.isRequired,
      retrieveTopicPreviewBegin:                    PropTypes.bool.isRequired,
      retrieveTopicPreviewSuccess:                  PropTypes.bool.isRequired,
      retrieveTopicPreviewFailure:                  PropTypes.bool.isRequired,
      topicPreviewPosts:                            PropTypes.array.isRequired,
      topicPreviewTotalPostsCount:                  PropTypes.number,
      topicPreviewTotalCommentsCount:               PropTypes.number,
      topicPreviewEstimatedProcessingTimeInHours:   PropTypes.number,
      fileInfoAfterValidation:                      PropTypes.object,
      fileValidationErrors:                         PropTypes.array.isRequired,
      handleFileValidation:                         PropTypes.func.isRequired,
      handleFileUpload:                             PropTypes.func.isRequired,
      clearUploadedFileAndReturnToUploadFilesOrEditTopicModal: PropTypes.func.isRequired,
      handleFinishUploadDataTopicCreation:          PropTypes.func.isRequired,
      postUploadedFile:                             PropTypes.func.isRequired,
      handleRemoveRowsWithErrors:                   PropTypes.func.isRequired,
      handleRemoveRowsWithErrorsConfirmation:       PropTypes.func.isRequired,
      handleRemoveRowsWithErrorsCancellation:       PropTypes.func.isRequired,
      handleUserInputDateForUploadedComments:       PropTypes.func.isRequired,
      handleUserInputLanguageForUploadedComments:   PropTypes.func.isRequired,
      uploadedFileName:                             PropTypes.string,
      cleanedFileData:                              PropTypes.array,
      totalDataPointsForUploadedFile:               PropTypes.number,
      handleUploadedFileTopicCreationCancellation:  PropTypes.func.isRequired,
      handleReturnBackToPreviousModalFromCancelTopicCreationModal: PropTypes.func.isRequired,
      allUploadedData:                              PropTypes.array.isRequired,
      allUploadedFilesForTopic:                     PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      modalState: this.props.modalState
    };
  }

  componentWillUnmount() {
    document.body.classList.remove('modal-open');
  }
 
  static contextType = GaContext;
  componentDidMount() {
    const {ReactGA} = this.context;
    ReactGA.pageview('/dashboard/topics/addTopic');
    this.setState({
      modalState: this.props.modalState
    });
    if (this.props.show) {
      document.body.classList.add('modal-open');
    }
  }

  returnModalBasedOnModalState() {
    const modalState = this.props.modalState;
    switch(modalState) {
      case CHOOSE_DATA_SOURCE_TOPIC_MODAL_STATE:
        return this.returnChooseDataSourceModal();
      
      case KEYWORD_FILTERING_TOPIC_MODAL_STATE:
        return this.returnKeywordFilteringAddTopicModal();

      case UPLOAD_DATA_TOPIC_DETAILS_MODAL_STATE:
        return this.returnUploadDataTopicDetailsModal();

      case UPLOAD_FILES_MODAL_STATE:
        return this.returnUploadFilesModal();

      case LOADING_MODAL_STATE:
        return this.returnLoadingModal();

      case DATA_SUMMARY_WITH_ERRORS_MODAL_STATE:
        return this.returnDataSummaryWithErrorsModal();
      
      case DATA_SUMMARY_MODAL_STATE:
        return this.returnDataSummaryModal();

      case REMOVE_ROWS_WITH_ERRORS_CONFIRMATION_STATE:
        return this.returnRemoveRowsWithErrorsConfirmationModal();

      case CONFIRM_CANCEL_TOPIC_CREATION_STATE:
        return this.returnconfirmCancelTopicCreationModal();

      case EDIT_TOPIC_MODAL_STATE:
        return this.returnEditTopicModal();

      default:
        return; 
    }
  }

  returnChooseDataSourceModal() {
    return (
      <ChooseDataSourceModal
        show={this.props.show}
        toggleModal={this.props.toggleModal}
        changeModalState={e => this.props.changeModalState(e)}
        changeAddTopicActionType={e => this.props.changeAddTopicActionType(e)}
      />
    );
  }

  returnKeywordFilteringAddTopicModal() {
    return (
      <AddTopic
        show={this.props.show}
        toggleModal={this.props.toggleModal}
        type={this.props.type}
        createTopics={e => this.props.createTopics(e)}
        retrieveTopicPreview={e => this.props.retrieveTopicPreview(e)}
        topicData={this.props.topicData}
        allCategories={this.props.allCategories}
        resetAddTopicForm={this.props.resetAddTopicForm}
        createTopicsBeginStatus={this.props.createTopicsBeginStatus}
        updateTopicsBegin={this.props.updateTopicsBegin}
        allTopicNames={this.props.allTopicNames}
        topicPreviewPosts={this.props.topicPreviewPosts}
        topicPreviewTotalPostsCount={this.props.topicPreviewTotalPostsCount}
        topicPreviewTotalCommentsCount={this.props.topicPreviewTotalCommentsCount}
        topicPreviewEstimatedProcessingTimeInHours={this.props.topicPreviewEstimatedProcessingTimeInHours}
        retrieveTopicPreviewBegin={this.props.retrieveTopicPreviewBegin}
        retrieveTopicPreviewSuccess={this.props.retrieveTopicPreviewSuccess}
        retrieveTopicPreviewFailure={this.props.retrieveTopicPreviewFailure}
      />
    );
  }

  returnEditTopicModal() {
    return (
      <EditTopicModal
        show={this.props.show}
        toggleModal={this.props.toggleModal}
        createTopics={e => this.props.createTopics(e)}
        topicData={this.props.topicData}
        allCategories={this.props.allCategories}
        resetAddTopicForm={this.props.resetAddTopicForm}
        updateTopicsBegin={this.props.updateTopicsBegin}
        allTopicNames={this.props.allTopicNames}
        changeModalState={e => this.props.changeModalState(e)}
        handleFileValidation={e => this.props.handleFileValidation(e)}
        handleFileUpload={e => this.props.handleFileUpload(e)}
        allUploadedFilesForTopic={this.props.allUploadedFilesForTopic}
      />
    );
  }

  returnUploadDataTopicDetailsModal() {
    return (
      <UploadDataTopicDetailsModal
        show={this.props.show}
        toggleModal={this.props.toggleModal}
        createTopics={e => this.props.createTopics(e)}
        allCategories={this.props.allCategories}
        resetAddTopicForm={this.props.resetAddTopicForm}
        createTopicsBeginStatus={this.props.createTopicsBeginStatus}
        allTopicNames={this.props.allTopicNames}
      />
    );
  }

  returnUploadFilesModal() {
    return (
      <UploadFilesModal
        show={this.props.show}
        toggleModal={this.props.toggleModal}
        topicData={this.props.newUploadDataTopicData}
        handleFileValidation={e => this.props.handleFileValidation(e)}
        handleFileUpload={e => this.props.handleFileUpload(e)}
        handleFinishUploadDataTopicCreation={this.props.handleFinishUploadDataTopicCreation}
        allUploadedData={this.props.allUploadedData}
      />
    );
  }

  returnLoadingModal() {
    return (
      <LoadingModal
        show={this.props.show}
        uploadedFileName={this.props.uploadedFileName}
        clearUploadedFileAndReturnToUploadFilesOrEditTopicModal={this.props.clearUploadedFileAndReturnToUploadFilesOrEditTopicModal}
      />
    );
  }

  returnDataSummaryWithErrorsModal() {
    return (
      <DataSummaryWithErrorsModal 
        show={this.props.show}
        toggleModal={this.props.toggleModal}
        fileInfoAfterValidation={this.props.fileInfoAfterValidation}
        totalDataPointsForUploadedFile={this.props.totalDataPointsForUploadedFile}
        fileValidationErrors={this.props.fileValidationErrors}
        handleRemoveRowsWithErrors={this.props.handleRemoveRowsWithErrors}
        clearUploadedFileAndReturnToUploadFilesOrEditTopicModal={this.props.clearUploadedFileAndReturnToUploadFilesOrEditTopicModal}
      />
    );
  }

  returnDataSummaryModal() {
    return (
      <DataSummaryModal 
        show={this.props.show}
        toggleModal={this.props.toggleModal}
        fileInfoAfterValidation={this.props.fileInfoAfterValidation}
        totalDataPointsForUploadedFile={this.props.totalDataPointsForUploadedFile}
        clearUploadedFileAndReturnToUploadFilesOrEditTopicModal={this.props.clearUploadedFileAndReturnToUploadFilesOrEditTopicModal}
        postUploadedFile={this.props.postUploadedFile}
        cleanedFileData={this.props.cleanedFileData}
        handleUserInputDateForUploadedComments={e => this.props.handleUserInputDateForUploadedComments(e)}
        handleUserInputLanguageForUploadedComments={e => this.props.handleUserInputLanguageForUploadedComments(e)}
      />
    );
  }

  returnRemoveRowsWithErrorsConfirmationModal() {
    return (
      <RemoveRowsConfirmationModal 
        show={this.props.show}
        handleRemoveRowsWithErrorsCancellation={this.props.handleRemoveRowsWithErrorsCancellation}
        handleRemoveRowsWithErrorsConfirmation={this.props.handleRemoveRowsWithErrorsConfirmation}
      />
    );
  }

  returnconfirmCancelTopicCreationModal() {
    return (
      <CancelTopicCreationModal 
        show={this.props.show}
        toggleModal={this.props.toggleModal}
        handleUploadedFileTopicCreationCancellation={this.props.handleUploadedFileTopicCreationCancellation}
        handleReturnBackToPreviousModalFromCancelTopicCreationModal={this.props.handleReturnBackToPreviousModalFromCancelTopicCreationModal}
      />
    );
  }

  render() {
    const { toggleModal, modalState } = this.props;

    const closeOnOutsideClick = !MODAL_STATES_REQUIRING_CANCEL_CONFIRMATION.includes(modalState);

    return (
      <Modal handleClick={() => toggleModal(false)} closeOnOutsideClick={closeOnOutsideClick}>
        {this.returnModalBasedOnModalState()}   
      </Modal>
    );
  }
}

export default withFirebase(CreateTopicModalManager);



// WEBPACK FOOTER //
// ./src/features/topics/components/CreateTopicModalManager.js